export default {
   //webApi: "http://localhost:5000/api"
   webApi: "https://mealplanner2020api.azurewebsites.net/api"
}